<script setup lang="ts">
import NumberField from '@/components/forms/NumberField/NumberField.vue';
import { computed, ref } from 'vue';
import { getAbbreviation, type Quantity, getUnitClass, getUnitName } from '@ptw-p3/unitsnet-js-ptw';
import _ from 'lodash';
import { IQuantityTypeEnum } from '@/api/generator';
import { watchEffect } from 'vue';
import type { QuantityInputProps } from '../types';

const props = defineProps<QuantityInputProps>();

const emits = defineEmits<{
  'update:modelValue': [Quantity | undefined];
  blur: [Event];
}>();

const input = ref<number | undefined>();

watchEffect(() => {
  input.value =
    props.modelValue?.value && props.displayUnit
      ? (getUnitClass(getUnitName(props.displayUnit)) as any)
          .FromQuantity(props.modelValue)
          .toValue(props.displayUnit)
      : props.modelValue?.value;
});

function onUpdate(value: number | undefined) {
  emits(
    'update:modelValue',
    _.isUndefined(value)
      ? undefined
      : {
          value,
          unit: props.displayUnit,
          $type:
            IQuantityTypeEnum.UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet,
        },
  );
}

function onBlur(event: FocusEvent) {
  emits('blur', event);
}

const bindings = computed(() => ({
  props: {
    ...props,
    emptyValue: undefined,
    modelValue: input.value,
    suffix: getAbbreviation(props.displayUnit),
  },
  on: {
    'update:modelValue': onUpdate,
    blur: onBlur,
  },
}));
</script>

<template>
  <NumberField v-bind="bindings.props" v-on="bindings.on" />
</template>
